import React, { memo } from 'react'
import { SnackbarProvider } from 'notistack'

const SnackBarProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return (
    <SnackbarProvider maxSnack={3} autoHideDuration={5000}>
      {children}
    </SnackbarProvider>
  )
}

export default memo(SnackBarProvider)
